import { Empty, Button } from 'antd';
import CustomResponsiveTable from '../CustomResponsiveTable';
import { IVendorMaterial } from '../../interfaces/Material.Interface';
import { CheckCircleFilled } from '@ant-design/icons';
import {
	ANGLE,
	CHANNEL,
	PLATE,
	RECTANGLE_BAR,
	RECTANGLE_TUBE,
	ROUND_BAR,
	ROUND_TUBE,
} from '../../config/constants';

interface Props {
	data: IVendorMaterial[];
	isLoading: boolean;
	recordsTotal: number;
	currentPage: number;
	onChange: () => void;
	onChangePage: (page: number) => void;
	selectedShape: string | undefined;
	setSelectedVendorMaterial: (record: IVendorMaterial) => void;
	setShowWriteModalVendorMaterial: () => void;
}

const VendorMaterialsTable = (props: Props) => {
	const tableColumns: any = [
		{
			title: 'Vendor',
			render: (record: IVendorMaterial) => `${record?.vendor?.display_name}`,
			visible: true,
			sorter: true,
			key: 'vendor',
		},
		{
			title: 'Material Type',
			render: (record: IVendorMaterial) => `${record?.type?.display_name}`,
			visible: true,
			sorter: true,
			key: 'type',
		},
		{
			title: 'Height',
			render: (record: IVendorMaterial) => Number(record.height),
			visible:
				props.selectedShape === RECTANGLE_BAR ||
				props.selectedShape === RECTANGLE_TUBE ||
				props.selectedShape === PLATE ||
				props.selectedShape === ANGLE ||
				props.selectedShape === CHANNEL,
			key: 'height',
			sorter: true,
		},
		{
			title: 'Width',
			render: (record: IVendorMaterial) => Number(record.width),
			visible:
				props.selectedShape === RECTANGLE_BAR ||
				props.selectedShape === RECTANGLE_TUBE ||
				props.selectedShape === PLATE ||
				props.selectedShape === ANGLE ||
				props.selectedShape === CHANNEL,
			key: 'width',
			sorter: true,
		},
		{
			title: 'Outer Diameter',
			render: (record: IVendorMaterial) => Number(record.outer_diameter),
			visible:
				props.selectedShape === ROUND_BAR || props.selectedShape === ROUND_TUBE,
			key: 'outer_diameter',
			sorter: true,
		},
		{
			title: 'Inner Diameter',
			render: (record: IVendorMaterial) => Number(record.inner_diameter),
			visible: props.selectedShape === ROUND_TUBE,
			key: 'inner_diameter',
			sorter: true,
		},
		{
			title: 'Wall Thickness',
			render: (record: IVendorMaterial) => Number(record.wall_thickness),
			visible:
				props.selectedShape === RECTANGLE_TUBE ||
				props.selectedShape === ANGLE ||
				props.selectedShape === CHANNEL,
			key: 'wall_thickness',
		},
		{
			title: 'Vendor Part #',
			render: (record: IVendorMaterial) =>
				`${record?.vendor_part_number ? record?.vendor_part_number : ''}`,
			visible: true,
			key: 'vendor_part_number',
		},
		{
			title: 'Vendor Description',
			render: (record: IVendorMaterial) => record.vendor_description,
			key: 'vendor_description',
			visible: true,
			ellipsis: true,
		},
		{
			title: 'Available',
			render: (record: IVendorMaterial) => record.availability_status == 'Available' ? 'Yes' : 'No',
			key: 'availability_status',
			visible: true,
			ellipsis: true,
			sorter: true,
		},
		{
			title: 'Standard',
			render: (record: IVendorMaterial) =>
				record.is_standard_size ? (
					<div style={{ color: '#52c41a' }}>
						<CheckCircleFilled /> Standard
					</div>
				) : null,
			visible: true,
			sorter: true,
			key: 'is_standard_size',
		},
		{
			title: 'Lengths',
			visible: true,
			render: (record: IVendorMaterial) => {
				return record.lengths.map((length) => Number(length.length)).join(', ');
			},
			sorter: true,
		},
		{
			title: 'Actions',
			key: 'select',
			render: (record: IVendorMaterial) => (
				<div>
					<Button
						type="link"
						onClick={() => {
							props.setSelectedVendorMaterial(record);
							props.setShowWriteModalVendorMaterial();
						}}
					>
						View/Edit
					</Button>
				</div>
			),
			visible: true,
		},
	].filter((col) => col.visible);

	return (
		<div>
			<CustomResponsiveTable
				scroll={{ x: '720px' }}
				columns={tableColumns}
				data={props.data.length > 0 ? props.data : []}
				loading={props.isLoading}
				emptyTable={emptyTable}
				key={0}
				rowKey="id"
				onChange={props.onChange}
				pagination={{
					pageSize: 20,
					current: props.currentPage,
					pageSizeOptions: [],
					total: props.recordsTotal,
					onChange: (page) => {
						props.onChangePage(page);},
					defaultPageSize: 20,
					showSizeChanger: false,
				}}
			/>
		</div>
	);
};

const emptyTable = () => {
	return (
		<Empty
			image={Empty.PRESENTED_IMAGE_SIMPLE}
			description={
				<span style={{ color: '#000' }}>
					There are currently no materials to be displayed.
				</span>
			}
		/>
	);
};

export default VendorMaterialsTable;
